<template>
  <div class v-if="!detailView" v-bind:style="{ height: height + 'px'}">
    <Loading :loading="show_loading"></Loading>

    <div class="content_header" style>
      <v-toolbar flat color="white mx-2">
        <v-toolbar-title>リダイレクト管理</v-toolbar-title>

        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          id="data_search"
          class="mx-4 pa-4"
          @keydown.enter="trigger"
          placeholder="検索"
        ></v-text-field>

        <!-- 詳細ダイアログ -->
        <v-dialog v-model="dialog2" max-width="500px">
          <v-card class="pa-6">
            <v-card-title class="px-0">
              <span class="headline">{{ detail_title }}</span>
            </v-card-title>

            <v-simple-table border="1">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">アクション</th>
                    <th class="text-center">クリック数</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th class="text-center subtitle-1">ios</th>
                    <td class="text-center subtitle-1">{{ detail_items.ios || 0}}</td>
                  </tr>
                  <tr>
                    <th class="text-center subtitle-1">android</th>
                    <td class="text-center subtitle-1">{{ detail_items.android || 0 }}</td>
                  </tr>
                  <tr>
                    <th class="text-center subtitle-1">pc</th>
                    <td class="text-center subtitle-1">{{ detail_items.pc|| 0 }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="backList" :disabled="processing">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 新規・更新ダイアログ -->
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" @click="newItem()" v-on="on">新規追加</v-btn>
          </template>
          <LoadingCircle :loading="show_loading"></LoadingCircle>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form ref="form_check">
                  <v-row>
                    <!-- 名称設定 -->
                    <v-col cols="12" sm="10" md="10">
                      <v-text-field
                        v-model="editedItem.category"
                        label="名称"
                        :disabled="read_only"
                        :rules="[required]"
                        counter="255"
                      ></v-text-field>
                    </v-col>

                    <!-- 種別設定(選んだ項目で表示制御) -->
                    <v-col cols="6" sm="6" md="6">
                      <v-select
                        label="種別を選択"
                        v-model="editedItem.type"
                        item-text="label"
                        item-value="value"
                        :items="typelist"
                        return-object
                      ></v-select>
                    </v-col>

           <v-col cols="6" sm="6" md="6">
              <v-text-field
                        v-model="editedItem.itunes_id"
                        label="itunes_id(任意)"
                        counter="500"
                      ></v-text-field>
                    </v-col>

                  </v-row>

                  <!-- タイプ: 公式サイト -->
                  <v-row v-if="editedItem.type.value == 'site'">
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        v-model="editedItem.pc"
                        label="公式サイトのURL"
                        counter="500"
                        :rules="[required]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-textarea
                        row="3"
                        auto-grow
                        outlined
                        v-model="editedItem.memo"
                        label="メモ"
                        counter="1000"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <!-- タイプ: アプリ -->

                  <v-row v-if="editedItem.type.value == 'appli'">
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        v-model="editedItem.ios"
                        label="iOSのURL"
                        counter="500"
                        :rules="[required]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        v-model="editedItem.android"
                        label="AndroidのURL"
                        counter="500"
                        :rules="[required]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        v-model="editedItem.pc"
                        label="PCのURL"
                        counter="500"
                        :rules="[required]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-textarea
                        row="3"
                        auto-grow
                        outlined
                        v-model="editedItem.memo"
                        label="メモ"
                        counter="1000"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <!-- タイプ: その他 -->

                  <v-row v-if="editedItem.type.value == 'other'">
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        v-model="editedItem.pc"
                        label="公式サイトのURL"
                        counter="255"
                        :rules="[required]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-textarea
                        row="3"
                        auto-grow
                        outlined
                        v-model="editedItem.memo"
                        label="メモ"
                        counter="1000"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close" :disabled="processing">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="save" :disabled="processing">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </div>

    <v-snackbar v-model="snackbar" :timeout="timeout" top color="green">
      {{ snackbar_text }}
      <v-btn color="white" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="ma-6 pa-2">
      <div class="pa-1 body-2">
        ・赤字の
        <span class="red--text">XX</span>には該当のIDを設定してください。
      </div>
      <v-simple-table border dense class="custom_table">
        <tr>
          <th width="140">共通(自動判定)</th>
          <td v-html="memo1"></td>
        </tr>
      </v-simple-table>

      <div class="pa-1 body-2">・osのパラメータをつけると、どの端末からクリックしても指定したosのURLに飛びます</div>

      <v-simple-table border dense class="custom_table">
        <tr>
          <th width="140">Android</th>
          <td v-html="memo2"></td>
        </tr>

        <tr>
          <th width="140">iOS</th>
          <td v-html="memo3"></td>
        </tr>
      </v-simple-table>
    </v-card>

    <v-card class="ma-6">
      <v-data-table
        :headers="headers"
        :items="ads_items"
        :items-per-page="25"
        :footer-props="{itemsPerPageOptions: [25, 50, 100, -1]}"
        sort-desc
        fixed
        :search="search"
        sort-by="ad_id"
        class="elevation-1 pa-4"
        style="min-height:450px"
      >
        <template v-slot:top></template>

        <!-- <template v-slot:item.ad_id="{ item }">
          <v-btn outlined class="transparent" @click="copyItem(item)">{{item.ad_id}}</v-btn>
        </template>-->

        <!-- <template v-slot:item.category="{ item }">
        <v-btn outlined class="transparent" @click="detail(item)">{{item.category}}</v-btn>
        </template>-->

        <template v-slot:item.type.label="{ item }" dense>
          <span :class="[item.type.value  , {batch: true}]">{{item.type.label}}</span>
        </template>

        <template v-slot:item.edit="{ item }">
          <v-btn outlined class="transparent" @click="editItem(item)">
            <v-icon small color="primary">fas fa-edit</v-icon>
          </v-btn>
        </template>

        <template v-slot:item.custom="{ item }">
          <div v-if="item.type.value == 'site'">
            <table class="os_custom_table">
              <tr>
                <td>
                  <span>
                    <img src="@/assets/ios.png" width="16" />
                    <img src="@/assets/android.png" width="16" />
                    <img src="@/assets/pc.png" width="16" />
                  </span>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{item.pc}}</span>
                    </template>
                    <span>{{item.pc}}</span>
                  </v-tooltip>
                </td>
              </tr>
            </table>
          </div>

          <div v-if="item.type.value == 'appli'">
            <table class="os_custom_table">
              <tr>
                <td>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <img src="@/assets/android.png" width="16" />
                        {{item.android}}
                      </span>
                    </template>
                    <span>{{item.android}}</span>
                  </v-tooltip>
                </td>
              </tr>
              <tr>
                <td>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <img src="@/assets/ios.png" width="16" />
                        {{item.ios}}
                      </span>
                    </template>
                    <span>{{item.ios}}</span>
                  </v-tooltip>
                </td>
              </tr>
              <tr>
                <td>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <img src="@/assets/pc.png" width="16" />
                        {{item.pc}}
                      </span>
                    </template>
                    <span>{{item.pc}}</span>
                  </v-tooltip>
                </td>
              </tr>
            </table>
          </div>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">More info about {{ item.category }}</td>
        </template>

        <template v-slot:item.delete="{ item }">
          <v-container class="pa-0">
            <v-form>
              <v-row>
                <v-col cols="4" sm="4" md="4">
                  <v-icon small color="primary" @click="deleteItem(item)">fas fa-trash</v-icon>
                </v-col>

                <v-col cols="4" sm="4" md="4">
                  <v-icon small color="primary" @click="copyItem(item)">fas fa-clipboard</v-icon>
                </v-col>

                <v-col cols="4" sm="4" md="4">
                  <v-icon small color="primary" @click="detail(item)">fas fa-chart-line</v-icon>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </template>
      </v-data-table>
    </v-card>
  </div>
  <div class="pa-6" v-else></div>
</template>


<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
// Ajax通信ライブラリ
import axios from "axios";
const LoadingCircle = () => import("@/components/LoadingCircle.vue");
const Loading = () => import("@/components/Loading.vue");

// import LoadingCircle from "@/components/LoadingCircle.vue";
// import Loading from "@/components/Loading.vue";

export default {
  name: "LIST",
  components: {
    Loading,
    LoadingCircle
  },
  data() {
    return {
      height: 300,
      //検索用パラメータ
      search: "",
      //一覧表示と詳細表示の切り替え
      detailView: false,
      //多重送信チェック
      processing: false,
      //編集不可の制御
      read_only: true,

      memo1:
        process.env.VUE_APP_REDIRECT_URL + '<span class="red--text">XX</span>',
      memo2:
        process.env.VUE_APP_REDIRECT_URL +
        '<span class="red--text">XX</span>&os=android',
      memo3:
        process.env.VUE_APP_REDIRECT_URL +
        '<span class="red--text">XX</span>&os=ios',

      //ローディング
      show_loading: false,

      dialog: false,

      dialog2: false,

      sortDesc: [true],

      //種別一覧
      typelist: [
        { label: "アプリ", value: "appli" },
        { label: "公式サイト", value: "site" }
        // { label: "その他", value: "other" }
      ],
      //種別のマッピング
      typeMapping: {},

      expanded: [],

      headers: [
        {
          text: "編集",
          align: "center",
          value: "edit",
          sortable: false,
          width: "44px"
        },
        {
          text: "ID",
          align: "center",
          value: "ad_id",
          width: "80px",
          fixed: true
        },

        {
          text: "種別",
          align: "center",
          value: "type.label",
          width: "90px",
          fixed: true
        },

        {
          text: "名称",
          align: "left",
          value: "category",
          width: "20%"
        },

        {
          text: "各種リンク先",
          align: "left",
          value: "custom",
          sortable: false,
          width: "35%"
        },

        {
          text: "メモ",
          align: "left",
          value: "memo",
          width: "20%"
        },

        // {
        //   text: "iOS",
        //   align: "center",
        //   value: "ios",
        //   width: "20%"
        // },
        // {
        //   text: "Android",
        //   align: "center",
        //   value: "android",
        //   width: "20%"
        // },
        // {
        //   text: "PC",
        //   align: "center",
        //   value: "pc",
        //   width: "20%"
        // },
        {
          text: "操作",
          align: "center",
          value: "delete",
          sortable: false,
          width: "10%"
        }
        // { text: "", value: "data-table-expand" }
      ],
      ads_items: [],
      detail_items: [],
      detail_title: "",
      editedIndex: -1,
      editedItem: {
        ad_id: -1,
        category: "",
        type: {},
        itunes_id: "",
        memo: "",
        ios: "",
        android: "",
        pc: ""
      },
      defaultItem: {
        ad_id: -1,
        category: "",
        itunes_id: "",
        type: {},
        memo: "",
        ios: "",
        android: "",
        pc: ""
      },

      snackbar: false,
      snackbar_text: "登録・更新しました！",
      timeout: 2000,
      // 入力規則
      required: value => !!value || "必ず入力してください" // 入力必須の制約
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "新規登録" : "編集";
    }
  },

  methods: {
    initialize() {},

    trigger(event) {
      //この処理がないと日本語での検索がうまいいかない
      //日本語入力中のEnterキー操作は無効にする
      if (event.keyCode !== 13) {
        // this.search = "白猫";
        console.log(document.getElementById("data_search").value);
        this.search = document.getElementById("data_search").value;
        return true;
      } else {
        // alert("2");
      }
    },
    newItem() {
      this.read_only = false;
      this.editedIndex = -1;
      this.editedItem = Object.assign(
        {},
        {
          ad_id: -1,
          category: "",
          type: "",
          ios: "",
          android: "",
          pc: ""
        }
      );
      // this.dialog = true
    },

    //詳細画面表示
    detail(item) {
      this.detail_title = item.ad_id + ":" + item.category;
      this.dialog2 = true;
      axios.get(process.env.VUE_APP_REDIRECT_API_DETAIL).then(response => {
        var tmp = response.data[item.ad_id];

        console.log(tmp);
        if (typeof tmp != "undefined") {
          this.detail_items = {
            // name: tmp.title,
            ios: tmp.data.ios,
            android: tmp.data.android,
            pc: tmp.data.pc
          };
        } else {
          this.detail_items = {
            // name: tmp.title,
            ios: 0,
            android: 0,
            pc: 0
          };
        }
      });
    },

    //一覧に戻る
    backList() {
      this.dialog2 = false;
    },

    copyItem(item) {
      const copyText = process.env.VUE_APP_REDIRECT_URL + item.ad_id;
      navigator.clipboard
        .writeText(copyText)
        .then(() => {
          alert("URLをコピーしました。そのまま記事に貼り付けてください");
        })
        .catch(e => {
          console.error(e);
        });
    },

    editItem(item) {
      console.log(item);
      this.read_only = true;
      this.editedIndex = this.ads_items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    save() {
      //入力チェック
      if (!this.$refs.form_check.validate()) {
        alert("必須項目を入力してください");
        return;
      }

      //  console.log("データ中身:" + JSON.stringify(this.editedItem));
      // return

      var self = this;
      self.processing = true;
      self.show_loading = true;

      //タイプがsiteのときは、AndroidとiosにPCのURLを入れる
      if (self.editedItem.type.value == "site") {
        self.editedItem.android = self.editedItem.pc;
        self.editedItem.ios = self.editedItem.pc;
      }

      console.log("データ中身:" + JSON.stringify(self.editedItem));

      axios
        .post(process.env.VUE_APP_REDIRECT_API_UPDATE, {
          data: this.editedItem
        })
        .then(function(response) {
          if (response.data["status"] == "success") {
            if (self.editedIndex > -1) {
              console.log("更新:" + JSON.stringify(self.editedItem));
              Object.assign(self.ads_items[self.editedIndex], self.editedItem);
              self.snackbar_text = "更新しました";
            } else {
              console.log("新規追加：" + JSON.stringify(self.editedItem));
              self.editedItem["ad_id"] = response.data["last_id"];
              self.ads_items.push(self.editedItem);
              self.snackbar_text = "新規に追加しました";
            }

            self.snackbar = true;
          } else {
            alert("ERROR:前回保存した状態と同じ内容で登録している可能性があります。");
            console.log(response.data);
          }
          self.processing = false;
          self.show_loading = false;
          self.close();
        });
    },
    //削除
    deleteItem(item) {
      var result = confirm("選択したデータを削除しますか？");
      if (result == false) {
        return;
      }

      var self = this;
      axios
        .post(process.env.VUE_APP_REDIRECT_API_DELETE, {
          data: item
        })
        .then(function(response) {
          if (response.data["status"] == "success") {
            const index = self.ads_items.indexOf(item);
            self.ads_items.splice(index, 1);
            self.snackbar_text = "削除しました";
            self.snackbar = true;
          } else {
            alert("更新失敗・・！");
            console.log(response.data);
          }
          self.close();
        });
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 100);
    },

    listItems() {
      this.show_loading = true;

      axios.get(process.env.VUE_APP_REDIRECT_API_LIST).then(response => {
        console.log(response);
        // v-data-tableを使うときは配列に格納する
        const items = [];
        const values = Object.values(response.data);
        values.forEach(value => {
          // var tmp = this.typelist.filter(e => e.value == value.type);
          //  if(tmp.length > 0){

          //  }
          // console.log(this.typeMapping[value.type]);

          const item = {
            ad_id: value.ad_id,
            category: value.category,
            itunes_id: value.itunes_id,
            type: this.typeMapping[value.type] || this.typeMapping["appli"],
            ios: value.ios,
            android: value.android,
            pc: value.pc,
            memo: value.memo || ""
          };
          items.push(item);
        });

        //コンポーネントのデータに代入
        this.ads_items = items;

        //コンテンツの高さ調整
        this.$nextTick(() => {
          // console.log(this.$el.clientHeight);
          this.height = this.$el.clientHeight + 100;
        });

        this.show_loading = false;
      });
    }
  },

  created: function() {
    //種別のマッピング
    this.typelist.forEach(val => {
      this.typeMapping[val.value] = { label: val.label, value: val.value };
    });

    //一覧取得
    this.listItems();
  }
};
</script>
<style scoped>
/* 必須 */
html {
  overflow: hidden !important;
}

.v-content__wrap {
  overflow: scroll !important;
}

.content_header {
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
  box-shadow: 0 1px 6px #bbb;
}

.router-link-active {
  text-decoration: none;
}

.v-navigation-drawer__content
  .v-list-group
  .v-list-group__header
  .v-list-item__icon.v-list-group__header__append-icon {
  min-width: 35px;
}

.custom_table table {
  /* border: solid 1px #000000 !important; */
  border-collapse: collapse !important;
}
.custom_table th {
  background: #f4f4f4;
}
.custom_table th,
.custom_table td {
  border: 1px solid #ddd;
}

.v-data-table td,
.v-data-table th {
  padding: 0 8px;
}

.batch {
  display: block;
  font-size: 11px;
  color: #fff;
  border-radius: 6px;
  font-weight: bold;
  padding: 2px 0;
}
.batch.site {
  background-color: #2196f3;
}
.batch.appli {
  background-color: #4caf50;
}
.v-data-table .os_custom_table tr,
.v-data-table .os_custom_table td {
  padding: 3px;
  height: auto;
  text-align: left;
  border: none !important;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 200px;
}
.v-data-table .os_custom_table td img {
  vertical-align: middle;
}
</style>